import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { Form } from "react-bootstrap";

import {
  fieldLEInformOptions,
  fieldAddressOptions,
  setOptions,
  getOptions,
  toggleSearchButton,
  setButtonVisibilityByAccess,
} from "./optionsInformationAboutEntity";

import { addNewStatementData } from "../../../../redux/statementReducer/actionsStatement";

import {
  customStyles,
  customErrorStyles,
} from "./../../../GeneralComponents/componentsForFormUniversal/selectWithSearchUniversal/optionsSelectWithSearch";

import styles from "./informationAboutEntity.module.css";
import { fetchWithToken } from "../../../../interceptors/fetchInterceptor";
import { API_GET_INFO_BY_REG_NUM, MAIN_URL, PORT_FOR_INTEGRATION } from "../../../../constants/constants";
import useChapterActionIdMatch from "../../../../hooks/useChapterActionIdMatch";

function InformationAboutEntity({
  inputData,
  updateNewData,
  saveKey,
  handleErrors,
  errors,
  mode,
  setErrorsFields,
  handleSearchButton,
  handleCustomError,
  handleOptionSelectChangeType,
}) {
  const dispatch = useDispatch();
  const [directoryLoad, setDirectoryLoad] = useState(false);
  const [options, setoptions] = useState({
    infoEntity: fieldLEInformOptions,
    address: fieldAddressOptions,
  });
  const [prevTypeChangeStatement, setPrevTypeChangeStatement] = useState(null);

  const optionsOblast = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.allOblast.map((el) => {
      return { ...el, key: "oblId" };
    });
  });

  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });

  const searchAccess = useChapterActionIdMatch(
    sortedMenuNames?.REG_INFORMATION_CHANGES?.searchEGR?.chapterActionId,
  );

  async function handleChangeSelectSearch(event) {
    if (event) {
      switch (true) {
        case Object.keys(event).includes("target"):
          updateNewData(event.target.id, event.currentTarget.value);
          if (!window.location.pathname.includes("reginformationchanges")) {
            dispatch(addNewStatementData({ [`${event.target.id}`]: event.currentTarget.value }));
          }
          break;
        case Object.keys(event).includes("key"):
          setoptions({
            infoEntity: fieldLEInformOptions,
            address: await setOptions(event.value, event.key),
          });
          if (setErrorsFields) {
            setErrorsFields();
          }
          switch (event.key) {
            case "rayonId": {
              updateNewData("gorodId", null);
              break;
            }
            case "oblId": {
              updateNewData("gorodId", null);
              updateNewData("rayonId", null);
              break;
            }
            default:
              break;
          }
          updateNewData(event.key, event.value);
          if (!window.location.pathname.includes("reginformationchanges")) {
            dispatch(addNewStatementData({ [`${event.key}`]: event.value }));
          }
          break;
        default:
          break;
      }
      if (saveKey) handleErrors();
    }
  }
  const getValueForSelectSearch = (el) => {
    const value = el.options.find((item) => item.value === inputData[el.key]);
    return value ? value : null;
  };

  const getUserInfoByUnp = async () => {
    const { unp } = inputData;

    // if (!!unp) {
    if (unp.trim().length !== 9 || !/^[\d]+$/.test(unp)) {
      handleCustomError("unp", "Для поиска введите 9 цифр");
      return;
    } else {
      handleSearchButton(true);

      const data = await fetchWithToken(
        MAIN_URL + PORT_FOR_INTEGRATION + API_GET_INFO_BY_REG_NUM + `?regNum=${unp}`,
      ).then(async (res) => {
        if (!res.ok) {
          handleCustomError("unp");
          setoptions({ infoEntity: toggleSearchButton(false), address: fieldAddressOptions });
          handleSearchButton(false);
        }
        return res.json();
      });

      for (const [key, value] of Object.entries(data)) {
        if (value) {
          updateNewData(key, value);
        }
      }
      setoptions({ infoEntity: toggleSearchButton(true), address: fieldAddressOptions });
      handleCustomError("unp");
      handleOptionSelectChangeType();
      handleSearchButton(false);
    }
    // } else {
    //   handleCustomError("unp", "Для поиска заполните поле УНП");
    // }
  };

  useEffect(() => {
    if (
      window.location.href.includes("reginformationchanges") &&
      inputData.changeType &&
      prevTypeChangeStatement != inputData.changeType
    ) {
      setPrevTypeChangeStatement(inputData.changeType);
    }
    async function setOptionsForAddress() {
      await setOptions(inputData["oblId"], "oblId");
      await setOptions(inputData["rayonId"], "rayonId");
      setoptions(getOptions);
    }
    setOptionsForAddress();
  }, [inputData]);
  useEffect(() => {
    if (directoryLoad) {
      setOptions(optionsOblast, "firstInit").then(() => setoptions(getOptions));
    }
  }, [directoryLoad]);
  useEffect(() => {
    if (Boolean(optionsOblast.length) && !directoryLoad) {
      setDirectoryLoad(true);
    }
  }, [optionsOblast]);

  useEffect(() => {
    setOptions({ ...options, interested: setButtonVisibilityByAccess(searchAccess) });
  }, [searchAccess]);
  return (
    <>
      <h3 className={styles["component-caption"]}>Сведения о заинтересованном лице</h3>
      <div className={styles["container-information"]}>
        <div
          className={`${
            mode === "view" ? styles["grid-container-entity-view"] : styles["grid-container-entity"]
          }`}>
          {Object.values(options.infoEntity).map((option) => {
            if (mode === "view") {
              return (
                <div className={`${styles["text-block"]} ${styles?.[`box-${option.key}`]}`}>
                  <p className={styles["option-label"]}>{option.value}</p>
                  <p className={styles["option-value"]}>
                    {option.type === "selectSearch"
                      ? option.options.find((elem) => elem.value === inputData?.[option.key])?.label || "—"
                      : option.type === "date" && inputData?.[option.key]
                      ? inputData?.[option.key].split("-").reverse().join(".")
                      : inputData?.[option.key] || "—"}
                  </p>
                </div>
              );
            } else {
              if (option.type === "text" || option.type === "date") {
                if (option.customButton) {
                  return (
                    <div className={styles[`box-${option.key}`]}>
                      <div className={option.customButton ? styles["custom-button-block"] : ""}>
                        <div className={styles[`block-${option.key}`]}>
                          <label className={styles["label"]}>
                            {option.value}
                            {option.required && mode !== "view" && (
                              <span className={styles["red_dot"]}>*</span>
                            )}
                          </label>
                          <input
                            id={option.key}
                            type={option.type}
                            onChange={(e) => handleChangeSelectSearch(e)}
                            className={`${styles["form-input"]} ${
                              (mode !== "view" && !!errors[option.key]) ||
                              (!!option.maxlength && inputData[option.key]
                                ? inputData[option.key].length > option.maxlength
                                : false)
                                ? styles["red_border"]
                                : ""
                            }`}
                            disabled={option.disabled || mode === "view"}
                            placeholder={mode !== "view" && option.placeholder}
                            value={inputData[option.key]}
                          />
                        </div>
                        {(mode === "add" || mode === "edit") && option.customButton && (
                          <div
                            id={"search"}
                            className={`${styles["custom-button"]} ${
                              option.buttonDisabled ? styles["custom-button-disabled"] : ""
                            }`}
                            disabled={option.buttonDisabled}
                            onClick={(e) => !option.buttonDisabled && getUserInfoByUnp(e)}>
                            {option.customIcon && <span className={styles["custom-icon"]}></span>}
                            <span>{option.buttonName}</span>
                          </div>
                        )}
                      </div>
                      {errors[option.key] && <div style={{ color: "red" }}>{errors[option.key]}</div>}
                    </div>
                  );
                } else {
                  return (
                    <Form.Group
                      controlId={`${option.key}`}
                      className={styles[`box-${option.key}`]}>
                      <label className={styles["label"]}>
                        {option.value}
                        {option.required && mode !== "view" && <span className={styles.red_dot}>*</span>}
                      </label>
                      <input
                        id={option.key}
                        placeholder={mode !== "view" && "Введите"}
                        onChange={(e) => handleChangeSelectSearch(e)}
                        type={option.type}
                        defaultValue={option.defaultValue}
                        value={inputData[option.key]}
                        readOnly={option.readOnly || mode === "view"}
                        disabled={mode === "view" ? true : false}
                        className={`${styles["form-input"]} ${
                          (mode !== "view" && !!errors[option.key]) ||
                          (!!option.maxlength && inputData[option.key]
                            ? inputData[option.key].length > option.maxlength
                            : false)
                            ? styles["red_border"]
                            : ""
                        }`}
                      />
                      {errors[option.key] && <div style={{ color: "red" }}>{errors[option.key]}</div>}
                    </Form.Group>
                  );
                }
              } else if (option.type === "selectSearch") {
                return (
                  <Form.Group className={styles[`box-${option.key}`]}>
                    <label className={styles["label"]}>
                      {option.value}
                      {option.required && mode !== "view" && <span className={styles.red_dot}>*</span>}
                    </label>
                    <Select
                      noOptionsMessage={() => "Нет данных"}
                      onChange={(e) => handleChangeSelectSearch(e)}
                      defaultValue={inputData[option.key]}
                      value={option.options.find((item) => item.value === inputData[option.key])}
                      styles={mode !== "view" && !!errors[option.key] ? customErrorStyles : customStyles}
                      classNamePrefix="select"
                      placeholder={mode !== "view" && "Выберите"}
                      id={option.key}
                      isDisabled={mode === "view" ? true : false}
                      isSearchable={option.isSearchable}
                      name={option.key}
                      options={option.options}
                    />
                    {errors[option.key] && <div style={{ color: "red" }}>{errors[option.key]}</div>}
                  </Form.Group>
                );
              }
            }
          })}
          {Object.values(options.address).map((option) => {
            if (mode === "view") {
              return (
                <div className={`${styles["text-block"]} ${styles?.[`box-${option.key}`]}`}>
                  <p className={styles["option-label"]}>{option.value}</p>
                  <p className={styles["option-value"]}>
                    {option.type === "selectSearch"
                      ? option.options.find((elem) => elem.value === inputData?.[option.key])?.label || "—"
                      : option.type === "date" && inputData?.[option.key]
                      ? inputData?.[option.key].split("-").reverse().join(".")
                      : option.defaultValue
                      ? inputData.oblId && option.defaultValue
                      : inputData?.[option.key] || "—"}
                  </p>
                </div>
              );
            } else {
              if (option.type === "text") {
                return (
                  <Form.Group
                    controlId={`${option.key}`}
                    className={styles[`box-${option.key}`]}>
                    <label className={styles["label"]}>
                      {option.value}
                      {option.required && mode !== "view" && <span className={styles.red_dot}>*</span>}
                    </label>
                    <input
                      id={option.key}
                      placeholder={mode !== "view" && "Введите"}
                      onChange={(e) => handleChangeSelectSearch(e)}
                      type={option.type}
                      defaultValue={option.defaultValue}
                      value={inputData[option.key]}
                      readOnly={option.readOnly || mode === "view"}
                      disabled={option.disabled || mode === "view" ? true : false}
                      className={`${styles["form-input"]} ${
                        (mode !== "view" && !!errors[option.key]) ||
                        (!!option.maxlength && inputData[option.key]
                          ? inputData[option.key].length > option.maxlength
                          : false)
                          ? styles["red_border"]
                          : ""
                      }`}
                    />
                    {errors[option.key] && <div style={{ color: "red" }}>{errors[option.key]}</div>}
                  </Form.Group>
                );
              } else if (option.type === "selectSearch") {
                return (
                  <div className={styles[`box-${option.key}`]}>
                    <label className={styles["label"]}>
                      {option.value}
                      {option.required && mode !== "view" && <span className={styles.red_dot}>*</span>}
                    </label>
                    <Select
                      noOptionsMessage={() => "Нет данных"}
                      styles={mode !== "view" && !!errors[option.key] ? customErrorStyles : customStyles}
                      onChange={(e) => handleChangeSelectSearch(e)}
                      classNamePrefix="select"
                      id={option.key}
                      value={getValueForSelectSearch(option)}
                      placeholder={mode !== "view" && "Выберите"}
                      isDisabled={option.disabled || mode === "view" ? true : false}
                      isSearchable={option.isSearchable}
                      name={option.key}
                      options={option.options}
                    />
                    {errors[option.key] && <div style={{ color: "red" }}>{errors[option.key]}</div>}
                  </div>
                );
              }
            }
          })}
        </div>
      </div>
    </>
  );
}

export default InformationAboutEntity;
